import styled from "styled-components";
import Button from "@8x8/oxygen-button";
import { ProgressBar } from "@8x8/oxygen-loaders";
import { FlexHorizontalContainer } from "@/react/features/styled/WidthContainers";

export const PbxCardsContainer = styled(FlexHorizontalContainer)`
  width: 100%;
  height: fit-content;
  flex-wrap: wrap;
  gap: 20px;
`;

export const PbxCardProgessBar = styled(ProgressBar)`
  padding: 1% 2% 1% 2%;
`;

export const MemoryInfoButton = styled(Button)`
  width: fit-content;
`;
